import React, { useState } from 'react';
import {
  Button,
  useMutation,
  useNotify,
  ReferenceInput,
  SimpleForm,
  useRefresh,
  TextInput,
  AutocompleteInput,
  required,
} from 'react-admin';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

import { makeStyles } from '@material-ui/styles';
import { thereWasProblem } from '../../Utils/messages';
import { Theme } from '../../Theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(0.5),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
  },
  content: { '& > *': { padding: '0 !important' } },
  buttonSpacing: {
    margin: '0rem 0rem 1rem 0rem;',
  },
}));

const SubstateChangeButton = (props) => {
  const notify = useNotify();
  const classes = useStyles();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState('');
  const [justification, setJustification] = useState('');

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setStatus('');
    setJustification('');
    setOpen(false);
  };

  const [handleSubmit, { loading }] = useMutation(
    {
      type: 'update',
      resource: 'loan-applications/assign-substate',
      payload: {
        id: props.id,
        data: { status, justification },
      },
    },
    {
      onSuccess: () => {
        handleClose();
        notify('Subestado asignado exitosamente');
        refresh();
      },
      onFailure: (error) => {
        notify(
          `${thereWasProblem}: ${
            (error.body.data ? error.body.data.error : error.body.error) ||
            'Fallo general'
          }`,
          'warning'
        );
      },
    }
  );

  return (
    <div className={classes.root}>
      <Button
        className={classes.buttonSpacing}
        endIcon={<AccountTreeIcon />}
        variant='contained'
        label='Asignar subestado'
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='xs'
        fullWidth
      >
        <MuiDialogTitle id='form-dialog-title' disableTypography>
          <Typography variant='h4'>Subestatus</Typography>
        </MuiDialogTitle>
        <DialogContent>
          <SimpleForm toolbar={<></>} className={classes.content}>
            <ReferenceInput
              fullWidth
              source='status'
              variant='outlined'
              reference='substates'
              validate={required()}
              filter={{
                parentState: props?.state?.id,
              }}
              resource='loan-applications'
            >
              <AutocompleteInput
                onSelect={(option) => setStatus(option.name)}
              />
            </ReferenceInput>
            <TextInput
              fullWidth
              variant='outlined'
              validate={required()}
              source='justification'
              resource='loan-applications'
              onBlur={(e) => setJustification(e.target.value)}
            />
          </SimpleForm>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            label='Cancelar'
            onClick={() => handleClose()}
            color='primary'
          />
          <Button
            label='Asignar'
            onClick={() => {
              if (justification && status) {
                handleSubmit();
                handleClose();
              }
            }}
            color='primary'
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SubstateChangeButton;
